import { useCallback, useEffect, useState } from 'react';

/** How long a hidden figure stays shown after a tap. */
export const REVEAL_MS = 3000;

/**
 * A figure hidden from the club manager until tapped: `toggle` shows it for 3 seconds (a second tap hides it
 * sooner). Used by the money figures on Balance bills.
 */
export function useReveal(): [shown: boolean, toggle: () => void] {
  const [shown, setShown] = useState(false);

  useEffect(() => {
    if (!shown) return;
    const t = setTimeout(() => setShown(false), REVEAL_MS);
    return () => clearTimeout(t);
  }, [shown]);

  const toggle = useCallback(() => setShown((s) => !s), []);
  return [shown, toggle];
}
